import { configureStore } from "@reduxjs/toolkit";
import reducers from "./reducers";

// provider, signer and wallet instances live in WalletSessionProvider (hooks/useWallet.jsx), the store stays serializable
// modal data may carry callbacks (ConfirmSwap's onConfirm), the serializable check skips it
export default function generateStore() {
  return configureStore({
    reducer: reducers,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: ["SET_MODAL_DATA"],
          ignoredPaths: ["modals.data"],
        },
      }),
  });
}
